import axios from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

// Error log for debugging - persists across page reloads
if (!window.__axiosErrorLog) {
    window.__axiosErrorLog = [];
}

const axiosInstance = axios.create({
    withCredentials: true, // CRITICAL: Enable cookies for all requests
});

axiosInstance.interceptors.request.use(
    (config) => {
        console.log('[Axios] 📤 Request:', {
            url: config.url,
            method: config.method,
            withCredentials: config.withCredentials,
        });
        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle ONLY explicit authentication errors (401, 403)
        const status = error.response?.status;
        
        const errorInfo = {
            timestamp: new Date().toISOString(),
            status,
            url: error.config?.url,
            method: error.config?.method,
            message: error.response?.data?.message,
            data: error.response?.data,
        };
        
        // Save to persistent log
        window.__axiosErrorLog.push(errorInfo);
        
        // Keep only last 20 errors
        if (window.__axiosErrorLog.length > 20) {
            window.__axiosErrorLog.shift();
        }
        
        console.log('[Axios Interceptor] Response error:', errorInfo);
        console.log('[Axios Interceptor] 📋 View all errors: window.__axiosErrorLog');
        
        if (status === 401 || status === 403) {
            // Token expired or invalid - redirect to login
            console.error('[Axios Interceptor] ❌ Authentication error:', status);
            
            // Clear any stored tokens
            localStorage.removeItem('accessToken');
            
            // Redirect to login if not already there
            if (!window.location.pathname.includes('/login')) {
                window.location.href = '/login';
            }
        } else if (status === 500) {
            // Log 500 errors but DON'T treat them as auth errors
            // Let the application handle them normally
            console.error('[Axios Interceptor] ⚠️ Server error 500:', error.response?.data);
        }
        
        return Promise.reject(
            (error.response && error.response.data) || 'Something went wrong'
        );
    }
);

export default axiosInstance;
